import { ROLES, RoleTypesValue } from '../../../constants/role';
import { useStateSelector } from '../../../store';
import InvestorModel from '../../Murabaha/models/murabaha_investor';

export const useUserRoleType = () => {
  const userState = useStateSelector((state) => state.user) as any;
  const { user_type, id, userType } = userState;
  //
  const isAdmin: boolean = user_type.includes(ROLES.ADMIN);
  const isManager: boolean = user_type.includes(ROLES.MANAGER);
  const isInvestor: boolean = user_type.includes(ROLES.INVESTOR);
  const isMurabahaRepresentative: boolean = user_type.includes(
    ROLES.MURABAHA_REPRESENTATIVE
  );
  const roles: RoleTypesValue[] = user_type;
  const currentRole: RoleTypesValue = userType;
  //
  const user = InvestorModel.fromJson(userState);

  return {
    id,
    isAdmin,
    isManager,
    isInvestor,
    isMurabahaRepresentative,
    roles,
    currentRole,
    user,
  };
};
